import InvoicingBase from "./InvoicingBase";

export default {
  INVOICING_BASE: InvoicingBase,
};
